const e = function () {
  return this || Function("return this")();
}(),
      t = Reflect.apply,
      n = Reflect.defineProperty,
      r = Object.freeze,
      l = Object.prototype.hasOwnProperty,
      o = Symbol.for,
      _process = process,
      i = _process.type,
      u = _process.versions,
      _module = module,
      a = _module.filename,
      s = _module.id,
      c = _module.parent,
      _ = x(u, "electron"),
      p = _ && "renderer" === i;

let d = "";
"string" == typeof s && s.startsWith("internal/") && (d = q("internal/esm/loader"));

const f = require("module"),
      _require = require("vm"),
      m = _require.Script,
      _m$prototype = m.prototype,
      y = _m$prototype.createCachedData,
      h = _m$prototype.runInNewContext,
      b = _m$prototype.runInThisContext,
      _require2 = require("path"),
      g = _require2.sep,
      _require3 = require("fs"),
      v = _require3.readFileSync,
      w = new f(s);

function q(e) {
  let t;

  try {
    const _require4 = require("internal/bootstrap/loaders"),
          n = _require4.internalBinding,
          r = n("natives");

    x(r, e) && (t = r[e]);
  } catch (e) {}

  return "string" == typeof t ? t : "";
}

function x(e, n) {
  return null != e && t(l, e, [n]);
}

function D() {
  return M(require, w, T), w.exports;
}

function O(e, t) {
  return D()(e, t);
}

function j(e, t) {
  try {
    return v(e, t);
  } catch (e) {}

  return null;
}

let C, F;
w.filename = a, w.parent = c;
let I = "",
    S = "";
"" !== d ? (S = d, F = {
  __proto__: null,
  filename: "esm.js"
}) : (I = __dirname + g + "node_modules" + g + ".cache" + g + "esm", C = j(I + g + ".data.blob"), S = j(__dirname + g + "esm" + g + "loader.js", "utf8"), null === C && (C = void 0), null === S && (S = ""), F = {
  __proto__: null,
  cachedData: C,
  filename: a,
  produceCachedData: "function" != typeof y
});
const k = new m("const __global__ = this;(function (require, module, __shared__) { " + S + "\n});", F);
let M, T;

if (M = p ? t(b, k, [{
  __proto__: null,
  filename: a
}]) : t(h, k, [{
  __proto__: null,
  global: e
}, {
  __proto__: null,
  filename: a
}]), T = D(), "" !== I) {
  const e = T.package.dir;
  let t = e.get(I);

  if (void 0 === t) {
    let n = C;
    void 0 === n && (n = null), t = {
      buffer: C,
      compile: new Map([["esm", {
        circular: 0,
        code: null,
        codeWithTDZ: null,
        filename: null,
        firstAwaitOutsideFunction: null,
        firstReturnOutsideFunction: null,
        mtime: -1,
        scriptData: n,
        sourceType: 1,
        transforms: 0,
        yieldIndex: -1
      }]]),
      meta: new Map()
    }, e.set(I, t);
  }

  const _T = T,
        n = _T.pendingScripts;
  let r = n.get(I);
  void 0 === r && (r = new Map(), n.set(I, r)), r.set("esm", k);
}

n(O, T.symbol.package, {
  __proto__: null,
  value: !0
}), n(O, T.customInspectKey, {
  __proto__: null,
  value: () => "esm enabled"
}), n(O, o("esm:package"), {
  __proto__: null,
  value: !0
}), r(O), module.exports = O;